import React, { useState } from "react";
import { toast } from "react-toastify";
import api from "utils/apiService";
import { DialogRoot } from "components/ui/dialog";
import {
  DialogActionTrigger,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@chakra-ui/react";
import { Button } from "components/ui/button";

const todayPlus = (days) => {
  const d = new Date();
  d.setDate(d.getDate() + days);
  return d.toISOString().split("T")[0];
};

const ExtendTrial = ({ userId, refetch }) => {
  const [extendUntil, setExtendUntil] = useState(todayPlus(7));
  const [reason, setReason] = useState("");
  const [saving, setSaving] = useState(false);

  const handleSubmit = async () => {
    if (!extendUntil) {
      toast.error("اختر تاريخ نهاية التجربة");
      return;
    }
    setSaving(true);
    const res = await api.patch("/subscriptions/extendUserTrial", {
      userId,
      extendUntil,
      reason: reason || undefined,
    });
    setSaving(false);
    if (res.error) {
      toast.error(res.error);
    } else {
      toast.success("تم تمديد التجربة بنجاح");
      if (refetch) refetch();
    }
  };

  return (
    <DialogRoot dir="rtl">
      <DialogTrigger asChild>
        <button className="rounded-full bg-blue-600 px-6 py-1 text-white transition-all hover:bg-blue-800">
          تمديد التجربة
        </button>
      </DialogTrigger>
      <DialogContent className="fixed top-1/2 -translate-x-1/2 -translate-y-1/2 bg-white text-gray-700 end-1/2 dark:bg-navy-800 dark:text-white">
        <DialogHeader>
          <DialogTitle className="text-xl font-bold">
            تمديد التجربة المجانية
          </DialogTitle>
        </DialogHeader>
        <DialogBody>
          <div className="mb-3 flex flex-col gap-1">
            <label className="text-sm">تمديد حتى:</label>
            <input
              type="date"
              value={extendUntil}
              min={todayPlus(1)}
              onChange={(e) => setExtendUntil(e.target.value)}
              className="rounded border border-gray-300 bg-white p-2 text-gray-800 dark:bg-navy-900 dark:text-white"
            />
          </div>
          <div className="flex flex-col gap-1">
            <label className="text-sm">سبب التمديد (اختياري):</label>
            <textarea
              rows={2}
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              className="rounded border border-gray-300 bg-white p-2 text-gray-800 dark:bg-navy-900 dark:text-white"
            />
          </div>
        </DialogBody>
        <DialogFooter>
          <Button onClick={handleSubmit} variant="outline" disabled={saving}>
            <span>{saving ? "جاري الحفظ" : "تمديد"}</span>
          </Button>
          <DialogActionTrigger asChild>
            <Button variant="outline">
              <span>إلغاء</span>
            </Button>
          </DialogActionTrigger>
        </DialogFooter>
        <DialogCloseTrigger />
      </DialogContent>
    </DialogRoot>
  );
};

export default ExtendTrial;
